import React from 'react';
import './Musician.css';

class Musician extends React.Component {
  render() {
    return (              
        <div className="musician-container">
            <img className="musician-pic" alt="" src={this.props.image} />
            <div className="musician-divider" />
            <h3 className="musician-label">{this.props.title}</h3>
        </div>
    )
  }
}

export default Musician;


// WEBPACK FOOTER //
// ./src/components/band/musician/Musician.js